import(/* webpackMode: "eager" */ "/vercel/path0/src/app/agents/[id]/page.tsx");
